import { EVENING_TIME, MORNING_TIME } from "../constant/constant";

export const DateToyyyymmdd = (d, num) => {
  // //("date--->-->", d);
  try {
    const [day, month, year] = d.split("-");
    // //(day, month, year);
    var date = new Date(year, month - 1, day, 0, 0, 0, 0);
    // //(d.toISOString());
  } catch {
    var date = new Date(d);
  }
  date.setDate(date.getDate() + num);
  // //("*****->", date);
  var y = date.getFullYear();
  var m = date.getMonth() + 1;
  var d1 = date.getDate();
  var yyyymmdd = y + "-" + m + "-" + d1;
  return yyyymmdd;
};

export const appendKeys = (obj1, obj2, keysToAppend) => {
  Object.keys(obj1).forEach((key) => {
    if (!keysToAppend.includes(key) && key !== "id" && key !== "family_id") {
      // Update non-array values only if not in keysToAppend and not 'id' or 'family_id'
      if (
        !Array.isArray(obj1[key]) &&
        obj1[key] !== null &&
        obj1[key] !== undefined
      ) {
        obj2[key] = obj1[key];
      }
    } else if (Array.isArray(obj1[key]) && Array.isArray(obj2[key])) {
      // Append array values only for keys in keysToAppend
      const valuesToAdd = obj1[key].filter(
        (value) => !obj2[key].includes(value)
      );
      obj2[key] = obj2[key].concat(valuesToAdd);
    }
  });

  return obj2;
};

export function isTherealphabet(input) {
  return /[a-zA-Z]/.test(input);
}

// function to get the current time in "hh:mm" format
export function getCurrentTime() {
  const now = new Date();
  const hours = now.getHours();
  const minutes = now.getMinutes();
  const ampm = hours >= 12 ? "PM" : "AM";

  // Convert hours from 24-hour format to 12-hour format
  const formattedHours = hours % 12 || 12;

  const formattedMinutes = String(minutes).padStart(2, "0");

  return `${formattedHours}:${formattedMinutes} ${ampm}`;
}

// function to get the current date in "22 Sept 2023" format
export function getCurrentDate() {
  const now = new Date();
  const options = { day: "numeric", month: "short", year: "numeric" };
  return now.toLocaleDateString("en-US", options);
}
// for debounce
export const debounce = (func, wait) => {
  let timeout;

  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), wait);
  };
};

export function getCurrentDateTime() {
  const now = new Date();
  //(now, "current date");
  return now.toISOString();
}

export const filterTwoArrays = (arr1, arr2, fieldName, fieldName2 = null) => {
  const array1 = arr1 || [];
  const array2 = arr2 || [];
  let filteredMedicineData;
  if (fieldName) {
    filteredMedicineData = array1?.filter((ele) => {
      const existingIndex = array2?.findIndex(
        (md) => md[fieldName] === ele[fieldName]
      );

      if (existingIndex === -1) {
        return ele;
      }
    });
  } else {
    filteredMedicineData = array1?.filter((ele) => {
      const existingIndex = array2?.findIndex(
        (md) => md.qp_cm_medicine_data_id.id === ele.id
      );

      if (existingIndex === -1) {
        return ele;
      }
    });
  }
  return filteredMedicineData;
};

export const handleKeyDown = (
  e,
  data,
  setSelectedOption,
  selectedOption,
  containerRef,
  afterEnter = () => {}
) => {
  if (e.key === "ArrowDown" && selectedOption < data.length - 1) {
    e.preventDefault();
    setSelectedOption((prev) => prev + 1);
  } else if (e.key === "ArrowUp" && selectedOption >= 0) {
    e.preventDefault();
    setSelectedOption((prev) => prev - 1);
  } else if (e.key === "Enter") {
    e.preventDefault();

    // selectedOption > -1
    //   ? document.getElementById(`${selectedOption}`).click()
    //   : afterEnter();
    afterEnter();

    setSelectedOption(-1);
  }
  // Scroll to the selected option
  if (selectedOption > -1) {
    const selectedElement = document.getElementById(`${selectedOption}`);
    containerRef.current.scrollTop =
      selectedElement.offsetTop - containerRef.current.offsetTop;
  }
};

export function filterDataByTagType(
  data,
  qp_cm_tags_id,
  tag_type,
  compare_with
) {
  const sortedArray = data
    ?.filter((ele) => {
      if (
        ele[qp_cm_tags_id] &&
        ele[qp_cm_tags_id][tag_type] &&
        ele[qp_cm_tags_id][tag_type] === compare_with
      ) {
        return ele;
      }
    })
    .map((ele) => ele);

  return sortedArray;
}
export function formatDate(inputDateString) {
  const inputDate = inputDateString ? new Date(inputDateString) : new Date();
  const options = { year: "numeric", month: "long", day: "numeric" };
  return inputDate.toLocaleDateString("en-US", options);
}
export function capitalizeFirstWord(input) {
  return input
    .toLowerCase()
    .replace(/^(.)|\s(.)/g, (match) => match.toUpperCase());
}

export const calculateAgeString = (birthdateString) => {
  const birthdate = new Date(birthdateString);
  const currentDate = new Date();

  const differenceInMilliseconds = currentDate - birthdate;
  const age = Math.floor(
    differenceInMilliseconds / (365.25 * 24 * 60 * 60 * 1000)
  );

  return age;
};

export const generateUUID = () => {
  const min = 100000;
  const max = 999999;
  const randomID = Math.floor(Math.random() * (max - min + 1)) + min;
  return randomID;
};

export const removeSpacesAndConvertToUppercase = (inputString) => {
  return inputString?.replace(/\s/g, "").toUpperCase();
};

export function calculateAge(dob) {
  if (!dob) return null;
  // Parse the date of birth string in the 'YYYY-MM-DD' format
  const [year, month, day] = dob?.split("-").map(Number);
  const birthDate = new Date(year, month - 1, day); // Create Date object (month is zero-based)
  const currentDate = new Date();

  // Calculate initial difference in years, months, and days
  let years = currentDate.getFullYear() - birthDate.getFullYear();
  let months = currentDate.getMonth() - birthDate.getMonth();
  let days = currentDate.getDate() - birthDate.getDate();

  // Adjust months and years if necessary
  if (days < 0) {
    months -= 1;
    days += new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      0
    ).getDate(); // Days in the previous month
  }
  if (months < 0) {
    years -= 1;
    months += 12;
  }

  // If the calculated age in years is less than 0, it means the birth date is in the future
  if (years < 0) {
    years = 0;
    months = 0;
    days = 0;
  }

  return { years, months, days };
}

export const filterOutBlankRows = (medicineData) => {
  const filteredData = medicineData?.filter((ele) => {
    return (
      ele?.qp_cm_medicine_data_id?.id !== null &&
      ele?.qp_cm_medicine_data_id?.medicine_name !== ""
    );
  });
  return filteredData;
};

export const deepCopy = (obj, visited = new WeakMap()) => {
  if (obj === null || typeof obj !== "object") {
    return obj;
  }

  if (visited.has(obj)) {
    return visited.get(obj);
  }

  const newObj = Array.isArray(obj) ? [] : {};
  visited.set(obj, newObj);

  for (let key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      newObj[key] = deepCopy(obj[key], visited);
    }
  }
  return newObj;
};

export const getFormattedDate = () => {
  const today = new Date();
  const day = String(today.getDate()).padStart(2, "0");
  const month = String(today.getMonth() + 1).padStart(2, "0"); // January is 0!
  const year = today.getFullYear();

  return `${day}-${month}-${year}`;
};

export const extractTimeFromTimestamp = (timestamp) => {
  const date = new Date(timestamp);
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();
  const formattedTime = `${hours}:${minutes}:${seconds}`;
  return formattedTime;
};

export const convertToCustomFormat = (inputTime) => {
  if (inputTime) {
    // Create a new Date object and set the time components from the inputTime
    let timeComponents = inputTime.split(":");
    let date = new Date();
    date.setHours(parseInt(timeComponents[0], 10));
    date.setMinutes(parseInt(timeComponents[1], 10));

    // Convert the time to UTC
    date.setUTCHours(date.getUTCHours() - 5);
    date.setUTCMinutes(date.getUTCMinutes() - 30);

    // Format the date in custom format
    let formattedString = `${date.getFullYear()}-${String(
      date.getMonth() + 1
    ).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}T${String(
      date.getHours()
    ).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}:00`;

    // Update state with formatted time
    return formattedString;
  }
};

export const checkTimeSlot = () => {
  let currentDate = new Date();
  let currentHour = currentDate.getUTCHours() + 5;
  let currentMinute = currentDate.getUTCMinutes() + 30;
  if (currentMinute >= 60) {
    currentHour += 1;
    currentMinute -= 60;
  }
  const morningStart = 9;
  const morningEnd = 18;
  const eveningStart = 18;
  const eveningEnd = 24;
  if (currentHour >= morningStart && currentHour < morningEnd) {
    return {
      start_time: MORNING_TIME.START_TIME,
      end_time: MORNING_TIME.END_TIME,
    };
  } else if (currentHour >= eveningStart && currentHour < eveningEnd) {
    return {
      start_time: EVENING_TIME.START_TIME,
      end_time: EVENING_TIME.END_TIME,
    };
  }
};

export const rearrangePrescription = (sequence, ele) => {
  if (ele) {
    const data = sequence.map((field) => {
      if (field.name === "Complaints") {
        return {
          data: filterDataByTagType(
            ele[field.offset],
            "qp_cm_tags_id",
            "tag_type",
            2
          ),
          key: "qp_cm_tags_id",
          extra_key: "remark",
          name: field.name,
          offset: field.offset,
        };
      }
      if (field.name === "Dignosis") {
        return {
          data: filterDataByTagType(
            ele[field.offset],
            "qp_cm_tags_id",
            "tag_type",
            1
          ),
          key: "qp_cm_tags_id",
          extra_key: "remark",
          name: field.name,
          offset: field.offset,
        };
      }
      if (field.name === "Test & Investigation") {
        return {
          data: filterDataByTagType(
            ele[field.offset],
            "qp_cm_tags_id",
            "tag_type",
            3
          ),
          key: "qp_cm_tags_id",
          extra_key: "remark",
          name: field.name,
          offset: field.offset,
        };
      }
      return {
        data: ele[field.offset],
        key: field.key,
        name: field.name,
        offset: field.offset,
      };
    });
    return data;
  } else {
    //("please pass valid data => ", ele);
  }
};

export function amountInWords(amount) {
  var words = [
    "",
    "One",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
    "Nine",
  ];
  var teensWords = [
    "",
    "Eleven",
    "Twelve",
    "Thirteen",
    "Fourteen",
    "Fifteen",
    "Sixteen",
    "Seventeen",
    "Eighteen",
    "Nineteen",
  ];
  var tensWords = [
    "",
    "",
    "Twenty",
    "Thirty",
    "Forty",
    "Fifty",
    "Sixty",
    "Seventy",
    "Eighty",
    "Ninety",
  ];
  var scales = ["", "Thousand", "Million", "Billion"];

  function capitalizeFirstLetter(word) {
    return word.charAt(0).toUpperCase() + word.slice(1);
  }

  function convertLessThanOneThousand(number) {
    var result = "";

    var hundreds = Math.floor(number / 100);
    var remainder = number % 100;

    if (hundreds > 0) {
      result += capitalizeFirstLetter(words[hundreds]) + " Hundred ";
    }

    if (remainder > 0) {
      if (remainder < 10) {
        result += capitalizeFirstLetter(words[remainder]) + " ";
      } else if (remainder < 20) {
        result += capitalizeFirstLetter(teensWords[remainder - 10]) + " ";
      } else {
        var tens = Math.floor(remainder / 10);
        var ones = remainder % 10;
        result += capitalizeFirstLetter(tensWords[tens]) + " ";
        if (ones > 0) {
          result += capitalizeFirstLetter(words[ones]) + " ";
        }
      }
    }

    return result;
  }

  function convertAmountToWords(amount) {
    if (amount === 0) {
      return "Zero";
    }

    var result = "";
    var i = 0;

    while (amount > 0) {
      if (amount % 1000 !== 0) {
        result =
          convertLessThanOneThousand(amount % 1000) + scales[i] + " " + result;
      }
      amount = Math.floor(amount / 1000);
      i++;
    }

    return result.trim();
  }

  return convertAmountToWords(amount);
}

export function shortenDateLabel(label) {
  const regex =
    /(January|February|March|April|May|June|July|August|September|October|November|December)/;

  return label.replace(regex, (match) => {
    const monthAbbr = match.substring(0, 3);
    return monthAbbr;
  });
}

export function replaceMonthAbbreviations(text) {
  const monthMap = {
    Jan: "January",
    Feb: "February",
    Mar: "March",
    Apr: "April",
    May: "May",
    Jun: "June",
    Jul: "July",
    Aug: "August",
    Sep: "September",
    Oct: "October",
    Nov: "November",
    Dec: "December",
  };

  return text.replace(
    /\b(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\b/g,
    (match) => monthMap[match]
  );
}

/**
 * PRINT A DIV ELEMENT
 * @param {HTMLDivElement} div
 */
export function print(div) {
  let innerHTML = `<!DOCTYPE html>
  <html lang="pt-BR">
  <head>   
  <meta charset="utf-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0" />
  <link href="/css/app.css" rel="stylesheet" />
  </head>
  <body>`;
  innerHTML += div.innerHTML + "</body></html>";
  //(innerHTML);
  let fakeIFrame = window.document.createElement("iframe");
  document.body.appendChild(fakeIFrame);
  let fakeContent = fakeIFrame.contentWindow;
  fakeContent.document.open();
  fakeContent.document.write(innerHTML);
  fakeContent.document.close();
  fakeContent.focus();
  fakeIFrame.addEventListener("load", () => {
    fakeContent.print();
  });
}

export const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
};

export const setCookie = (name, value, days) => {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = `expires=${date.toUTCString()}`;
  document.cookie = `${name}=${value};${expires};path=/`;
};

export const deleteCookie = (name) => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
};

export function convertCamelToTitle(camelStr) {
  // Use regular expressions to find uppercase letters and split the string
  const words = camelStr.match(/([A-Z][a-z]*)|([a-z]+)/g);

  // Join words with spaces and ensure the first word is capitalized
  const titleStr = words
    .join(" ")
    .replace(/^./, words[0].charAt(0).toUpperCase());

  return titleStr;
}

export function modifyString(str, toUpperCase = true) {
  // Remove all spaces
  let result = str.replace(/\s+/g, "");

  // Convert to upper or lower case based on the parameter
  if (toUpperCase) {
    result = result.toUpperCase();
  } else {
    result = result.toLowerCase();
  }

  return result;
}

export const getOrdinalSuffix = (number) => {
  if (number === 0) {
    return "";
  }
  const j = number % 10,
    k = number % 100;
  if (j == 1 && k != 11) {
    return number + "st";
  }
  if (j == 2 && k != 12) {
    return number + "nd";
  }
  if (j == 3 && k != 13) {
    return number + "rd";
  }
  return number + "th";
};

export function numberToWords(num) {
  const belowTwenty = [
    "Zero",
    "One",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
    "Nine",
    "Ten",
    "Eleven",
    "Twelve",
    "Thirteen",
    "Fourteen",
    "Fifteen",
    "Sixteen",
    "Seventeen",
    "Eighteen",
    "Nineteen",
  ];

  const tens = [
    "",
    "",
    "Twenty",
    "Thirty",
    "Forty",
    "Fifty",
    "Sixty",
    "Seventy",
    "Eighty",
    "Ninety",
  ];

  const thousands = ["", "Thousand", "Million", "Billion"];

  if (num === 0) return "Zero";

  function convertToWords(n) {
    if (n < 20) return belowTwenty[n];
    if (n < 100)
      return (
        tens[Math.floor(n / 10)] + (n % 10 ? " " + belowTwenty[n % 10] : "")
      );
    if (n < 1000)
      return (
        belowTwenty[Math.floor(n / 100)] +
        " Hundred" +
        (n % 100 ? " " + convertToWords(n % 100) : "")
      );
    return null;
  }

  let word = "";
  let i = 0;

  while (num > 0) {
    if (num % 1000 !== 0) {
      word =
        convertToWords(num % 1000) +
        (thousands[i] ? " " + thousands[i] : "") +
        (word ? " " + word : "");
    }
    num = Math.floor(num / 1000);
    i++;
  }

  return word.trim();
}

export function sumByKey(array, key) {
  if (!Array.isArray(array)) {
    throw new Error("The first argument must be an array of objects.");
  }

  return array.reduce((sum, obj) => {
    if (typeof obj[key] === "number") {
      return sum + obj[key];
    }
    return sum;
  }, 0);
}

export const calculateTaxes = (item) => {
  const quantity = Number(item.quantity) || 0;
  const unitPrice = Number(item.unit_price) || 0;
  const taxableValue = quantity * unitPrice;

  const cgst = (taxableValue * (item.cgst_rate || 0)) / 100;
  const sgst = (taxableValue * (item.sgst_rate || 0)) / 100;
  const igst = (taxableValue * (item.igst_rate || 0)) / 100;

  const discount =
    item.line_discount_type === "percentage"
      ? (taxableValue * (item.line_discount_value || 0)) / 100
      : item.line_discount_value || 0;

  const netTaxableValue = taxableValue - discount;

  return {
    taxableValue,
    discount,
    netTaxableValue,
    cgst,
    sgst,
    igst,
    totalTax: cgst + sgst + igst,
    totalAmount: netTaxableValue + cgst + sgst + igst,
  };
};

// Helper function to convert a string to Title Case
export const toTitleCase = (str) => {
  if (!str) return "";
  return str
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};
